import Breadcrumb from "./../../../components/Common/Breadcrumb"
import CodesStats from "./../../../pages/Dashboard/CodesStats/CodesStats"
import React from "react"
import { Col, Container, Row } from "reactstrap"
import CodePackInfo from "./CodePackInfo/CodePackInfo"

const CodesStatistics = ({ returnTranslation }) => {
  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={returnTranslation("Codes")} breadcrumbItem={returnTranslation("Code pack statistics")} />

        <Row>
          <Col sm="5">
            <CodePackInfo
              name="Code pack #1"
              description={"20% OFF"}
              createdAt={"25.04.2021"}
              expirationDate={"30.04.2021"}
            />
            <CodesStats />
          </Col>
          <Col sm="7"></Col>
        </Row>
      </Container>
    </div>
  )
}

export default CodesStatistics
